





define([
    'endpoints',
    'rest/request/requestFactory',
    'apiKeyNames'
],
function(endpoints, requestFactory, ApiKeyNames) {
    'use strict';

    var keyName = ApiKeyNames.search;

    return function() {
        return {
            reverseGeocode: requestFactory.single(endpoints.reverseGeocode, keyName),
            batch: requestFactory.batch(100, {
                single: endpoints.batchReverseGeocodeQuery,
                batch: endpoints.batchSearch,
                batchSync: endpoints.batchSyncSearch
            }, keyName)
        };
    };
});



// WEBPACK FOOTER //
// ./rest/reverseGeocode.js